// Filter bersama <-> query string URL. Murni, tanpa import.

export const RELATIVE_RANGES = ['today', 'yesterday', 'thisWeek', 'lastWeek', 'thisMonth', 'lastMonth'];
const INTERVALS = ['minute', 'hour', 'day', 'week'];
const UNIX_SECONDS = /^\d{1,11}$/;
const UNIX_MS = /^\d{12,13}$/;
const ISO_UTC = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d{1,3})?)?Z$/;
const LOCAL_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

// Alias link notifikasi (massId, from, to) ikut dibuang pas URL disinkronkan.
export const FILTER_GROUP_KEYS = {
  asset: ['asset', 'massId'],
  date: ['range', 'start', 'end', 'from', 'to'],
  interval: ['interval'],
};
export const FILTER_KEYS = ['asset', 'range', 'start', 'end', 'interval'];

export function filterToParams(filter, groups) {
  const params = {};
  const { massId } = filter;
  if (groups.includes('asset') && massId !== null && massId !== undefined && massId !== '') {
    params.asset = String(massId);
  }
  if (groups.includes('date')) {
    if (RELATIVE_RANGES.includes(filter.rangeType)) {
      params.range = filter.rangeType;
    } else if (Number.isFinite(filter.startMs) && Number.isFinite(filter.endMs)) {
      params.start = String(Math.floor(filter.startMs / 1000));
      params.end = String(Math.floor(filter.endMs / 1000));
    }
  }
  if (groups.includes('interval') && INTERVALS.includes(filter.interval)) {
    params.interval = filter.interval;
  }
  return params;
}

// from/to: detik atau milidetik unix, ISO UTC, atau tanggal lokal satu hari penuh.
function aliasToMs(value, isEnd) {
  if (UNIX_SECONDS.test(value)) return Number(value) * 1000;
  if (UNIX_MS.test(value)) return Number(value);
  if (ISO_UTC.test(value)) return Date.parse(value);
  const match = LOCAL_DATE.exec(value);
  if (!match) return NaN;
  const [year, month, day] = match.slice(1).map(Number);
  const date = isEnd ? new Date(year, month - 1, day, 23, 59, 59, 999) : new Date(year, month - 1, day);
  const valid = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
  return valid ? date.getTime() : NaN;
}

// Yang cacat dibuang diam-diam; halaman jalan pakai nilai store.
export function paramsToFilter(params, groups) {
  const filter = {};
  const asset = params.get('asset') || params.get('massId');
  if (groups.includes('asset') && asset) filter.massId = asset;
  if (groups.includes('date')) {
    const range = params.get('range');
    const start = params.get('start') || '';
    const end = params.get('end') || '';
    const fromMs = aliasToMs(params.get('from') || '', false);
    const toMs = aliasToMs(params.get('to') || '', true);
    if (RELATIVE_RANGES.includes(range)) {
      filter.rangeType = range;
    } else if (UNIX_SECONDS.test(start) && UNIX_SECONDS.test(end) && Number(start) < Number(end)) {
      filter.rangeType = 'custom';
      filter.startMs = Number(start) * 1000;
      filter.endMs = Number(end) * 1000;
    } else if (fromMs < toMs) {
      filter.rangeType = 'custom';
      filter.startMs = fromMs;
      filter.endMs = toMs;
    }
  }
  const interval = params.get('interval');
  if (groups.includes('interval') && INTERVALS.includes(interval)) filter.interval = interval;
  return filter;
}

// Cuma kelompok milik halaman yang ditimpa; menu, lat, lng, z tetap.
export function mergeFilterSearch(search, params, groups) {
  const query = new URLSearchParams(search);
  groups.forEach((group) => FILTER_GROUP_KEYS[group].forEach((key) => query.delete(key)));
  Object.keys(params).forEach((key) => query.set(key, params[key]));
  const out = query.toString();
  return out ? `?${out}` : '';
}

export function pickFilterQuery(search) {
  const query = new URLSearchParams(search);
  const picked = {};
  FILTER_KEYS.forEach((key) => {
    const value = query.get(key);
    if (value !== null && value !== '') picked[key] = value;
  });
  return picked;
}
